import { render, staticRenderFns } from "./ViewerCountWidgetPreview.vue?vue&type=template&id=584aea04"
import script from "./ViewerCountWidgetPreview.vue?vue&type=script&lang=js"
export * from "./ViewerCountWidgetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports